import { FrameworkStatus } from "../../helpers";

import { useDymoContext } from "./use-dymo-context";

export const useCheckDymoService = () => {
  const status = useDymoContext();

  return status === FrameworkStatus.loaded;
};
